import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import LoadingState from 'components/core/loading_state'
import {
  eventTypeSelector,
  fetchManagedEventTypeInvitations,
  fetchManagedEventTypeMemberships,
  invitationsisLoadedSelector,
  invitationsisLoadingSelector,
  invitationsListSelector,
  isLoadedSelector,
  isLoadingSelector,
  listSelector,
  resetInvitationsState,
  resetState
} from 'features/managed_event_types'

import { MembershipsTable } from './memberships_table'

export const OrganizationMemberships = () => {
  const dispatch = useDispatch()
  const { id } = useSelector(eventTypeSelector)
  const isLoading = useSelector(isLoadingSelector)
  const isLoaded = useSelector(isLoadedSelector)
  const isLoadingInvitations = useSelector(invitationsisLoadingSelector)
  const isLoadedInvitations = useSelector(invitationsisLoadedSelector)

  const memberships = useSelector(listSelector)
  const invitations = useSelector(invitationsListSelector)

  useEffect(() => {
    dispatch(fetchManagedEventTypeMemberships({ managedEventTypeId: id }))

    return () => dispatch(resetState())
  }, [dispatch, id])

  useEffect(() => {
    dispatch(fetchManagedEventTypeInvitations({ managedEventTypeId: id }))

    return () => dispatch(resetInvitationsState())
  }, [dispatch, id])

  if (isLoading || isLoadingInvitations) {
    return <LoadingState />
  }
  return (
    isLoaded && isLoadedInvitations && (memberships.length > 0 || invitations.length > 0) && <MembershipsTable />
  )
}
